/**
 * Created by mestrad on 2018. 06. 28..
 */

export default ResultList;
import Pagination from "../Pagination";
import Common from "../Common";
import Style from "../Style";
import SearchRequest from "./Request";

const $ = jQuery;

function ResultList(data, config) {
    var template;
    var $resultList = $(config.domElements.resultListWrapper);
    var $paginationContainer = $("#pagination-container");
    var html;
    var paginationConfig;
    init();

    function init() {
        saveSearchHistory(window.location.href);
        if (!data || !Array.isArray(data.items) || data.items.length == 0) {
            template = $(config.templates.resultListNoItem).html();
            html = Handlebars.compile(template);
            $resultList.html(html);
            $paginationContainer.addClass("nnpHidden");
            $("#nnpResultListExportBtn").addClass("nnpHidden");
            $(".nnpLoader").addClass("nnpHidden");
            $(config.domElements.searchForm).trigger("searchResultReceived", []);
            return;
        }
        if (config.objectType == "geo") {
            parentListSortReverse(data.items);
        }
        data.items.forEach(function (item) {
            item.actualDate = moment(Date.now()).format("YYYY-MM-DD");
        });

        template = $(config.templates.resultList).html();
        paginationConfig = {
            templates: {
                resultList: config.templates.resultList
            },
            domElements: config.domElements,
            data: data.items,
            paginationAttributes: data.pagination,
            resultPagination: $paginationContainer,
            resultList: $resultList,
            pageSize: config.limit,
            view: config.view,
            objectType: config.objectType,
            locale: config.locale,
            pages: config.pages
        };
        Pagination(paginationConfig);
        initEvents();

    }

    function saveSearchHistory(url) {
        if (!$('body').hasClass('logged-in')) {
            return null;
        }
        $.ajax({
            type: 'POST',
            dataType: 'JSON',
            url: myAjax.ajaxUrl,
            data: {
                action: 'save_search_history',
                searchUrl: url
            },
            success: function(response) {
//                console.log(response);
            }
        });
    }

    function parentListSortReverse(datas) {
        datas.forEach(function (data) {
            data.parentList.reverse();
        });
    }

    function initEvents() {
        $resultList.find( 'a' ).on( 'click', function ( e ) {
            var targetURL = e.target.href || e.target.parentElement.href;
            var urlObject = new URL( targetURL );
            if ( !! targetURL && (
                !! urlObject.pathname.split( '/' )[ 3 ] ||
                ! targetURL.includes( window.location.pathname )
            ) )
            {
                return true;
            }
            e.preventDefault();
            var id = Common.getUrlParam("id", this.getAttribute("href"));
            var actualDate = Common.getUrlParam("date", this.getAttribute("href"));
            window.history.pushState({}, "", this.getAttribute("href"));
            Style.hide($(config.domElements.searchWidget));
            Style.hide($(config.domElements.resultListWidget));
            $(config.domElements.eventHandlerNode).trigger("showDataSheet", [{
                id: id,
                actualDate: actualDate,
                parentSystemType: 0
            }]);
        });
        $(config.domElements.resultListAllCheckbox).on("change", function () {
            if (this.checked) {
                $(".nnpResultListCheckbox input").prop("checked", "checked");
            } else {
                $(".nnpResultListCheckbox input").removeProp("checked");
            }
        });
        $('#order_type_result_list').on("change", function () {
            var value = JSON.parse( $( '#order_type_result_list' ).val() );
            config.orderField = value.field;
            config.orderType = value.type;
            SearchRequest(config);
        } );
    }
}


